import { useQuery } from '@tanstack/react-query';
import { getProject } from '../../api/apiProjects';

export const useGetProject = (id) => {
    return useQuery({
        queryKey: ['project', id],
        queryFn: () => getProject(id),
        enabled: !!id,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};